<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="Aircraft"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="Tail Number"
        fieldId="tailNumber"
        v-model="formData.tailNumber"
        required
      />
      <AddEditFormGroup
        label="Model"
        fieldId="model"
        v-model="formData.model"
        required
      />
      <AddEditFormGroup
        label="Description"
        fieldId="description"
        v-model="formData.description"
        component="textarea"
        required
      />
      <AddEditFormGroup
        label="Home Airport"
        fieldId="homeAirport"
        v-model="formData.homeAirport"
        required
      />
      <AddEditFormGroup
        label="Type"
        fieldId="aircraftTypeId"
        v-model="formData.aircraftTypeId"
        component="select"
        :options="aircraftTypeOptions"
        @change="checkAircraftType"
        required
      />
      <AddEditFormGroup
        label="Hobbs"
        fieldId="hobbs"
        v-model="formData.hobbs"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Tach"
        fieldId="tach"
        v-model="formData.tach"
        type="number"
        step="any"
        :disabled="isSimulatorType"
      />
      <AddEditFormGroup
        label="Seats"
        fieldId="seats"
        v-model="formData.seats"
        type="number"
      />
      <AddEditFormGroup
        label="Fuel Capacity"
        fieldId="fuelCapacity"
        v-model="formData.fuelCapacity"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Useful Load"
        fieldId="usefulLoad"
        v-model="formData.usefulLoad"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Empty Weight"
        fieldId="emptyWeight"
        v-model="formData.emptyWeight"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Max Gross Weight"
        fieldId="maxGrossWeight"
        v-model="formData.maxGrossWeight"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Moment"
        fieldId="moment"
        v-model="formData.moment"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Color"
        fieldId="color"
        v-model="formData.color"
      />
      <AddEditFormGroup
        label="Charge Rate"
        fieldId="chargeRate"
        v-model="formData.chargeRate"
        type="number"
        step="any"
        required
      />
      <div class="form-group checkbox-group">
        <label for="ifrCertified">IFR Certified:</label>
        <input
          type="checkbox"
          id="ifrCertified"
          v-model="formData.ifrCertified"
        />
      </div>
      <FileUpload
        label="Aircraft Image"
        fieldId="image"
        v-model="formData.image"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import AircraftAPIService from "src/servicehandlers/AircraftAPIService.js";
import AddEditFormGroup from "./AddEditFormGroup.vue";
import AddEditTemplate from "./AddEditTemplate.vue";
import FileUpload from "../../../../components/HiloComponents/FileUpload.vue";
const aircraftAPIService = new AircraftAPIService();

export default {
  components: { FileUpload, AddEditTemplate, AddEditFormGroup },
  data() {
    return {
      isEditMode: false,
      loading: true,
      aircraftTypeOptions: [],
      isSimulatorType: null,
      formData: {
        tailNumber: "",
        model: "",
        hobbs: "",
        tach: "",
        homeAirport: "",
        description: "",
        seats: "",
        ifrCertified: false,
        fuelCapacity: "",
        usefulLoad: "",
        emptyWeight: "",
        maxGrossWeight: "",
        moment: "",
        color: "",
        image: null,
        chargeRate: "",
        aircraftTypeId: "",
      },
    };
  },
  async created() {
    await this.getAircraftTypes();
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getAircraft(this.$route.params.id);
    }
    this.loading = false;
  },
  methods: {
    async getAircraft(id) {
      try {
        this.formData = await aircraftAPIService.getById(id, this.$router);
        this.checkAircraftType(this.formData.aircraftTypeId);
      } catch (error) {}
    },
    async getAircraftTypes() {
      try {
        this.aircraftTypeOptions = await aircraftAPIService.getAircraftTypes();
      } catch (error) {}
    },
    checkAircraftType(newTypeId) {
      const simulatorType = this.aircraftTypeOptions.find(
        (type) => type.name === "Simulator",
      );
      if (simulatorType?.id === newTypeId) {
        this.formData.tach = "";
        this.isSimulatorType = true;
      } else {
        this.isSimulatorType = false;
      }
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await aircraftAPIService.update(this.$route.params.id, formData);
        } else {
          await aircraftAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.checkbox-group {
  display: flex;
  align-items: flex-start;
}

.checkbox-group label {
  margin-right: 10px;
}

.checkbox-group input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
